import { render, staticRenderFns } from "./PushTemplate.vue?vue&type=template&id=7f95ebfd&"
import script from "./PushTemplate.vue?vue&type=script&lang=ts&"
export * from "./PushTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PushTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports